module.exports = __webpack_public_path__ + "media/packs/images/update-icons/deliver-c89c6da2aa38f41707c822826b9bd031.svg";